import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppFeatures } from "../../../constants/featureFlags";
import { useFeature } from "../../../hooks/useFeature";

import { SettingsActionCreators } from "../../../redux/action-creators";
import { LanguageSwitcherApi } from "../../../redux/api";
import {
  LanguageSwitcherSelectors,
  UserContextSelectors
} from "../../../redux/selectors";

export const useLocalizationSettings = () => {
  const dispatch = useDispatch();

  const isSettingsEnabled = useFeature(AppFeatures.SETTINGS_DRAWER);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const publicationId = useSelector(LanguageSwitcherSelectors.publicationId);

  useEffect(() => {
    if (isSettingsEnabled) {
      const currentUrl = window.location.href;

      LanguageSwitcherApi.languageData(
        currentUrl,
        publicationId,
        isAuthenticated
      ).then(languageApiResponse => {
        const { response, errorResponse } = languageApiResponse;

        if (response) {
          dispatch(
            SettingsActionCreators.language.setTitle(
              response.languageSettings.title ?? "Choose your Language:"
            )
          );

          dispatch(
            SettingsActionCreators.language.setCurrent({
              title: response.languageSettings.current ?? "Choose your Country:"
            })
          );

          dispatch(
            SettingsActionCreators.language.setSettings(response.languages)
          );

          dispatch(
            SettingsActionCreators.country.setTitle(
              response.countrySettings.title
            )
          );

          dispatch(
            SettingsActionCreators.country.setSettings(response.countries)
          );
        } else if (errorResponse)
          console.error(
            `There is an error in API call. ${JSON.stringify(errorResponse)}`
          );
      });
    }
  }, [isSettingsEnabled, publicationId, isAuthenticated, dispatch]);
};
